import { Fade, Stack } from "@mui/material";
// import { organizationsApi, usersApi } from "api";
import React, {
  useRef,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
// import FastCreation from "./FastCreation";
import GroupsPanel from "./GroupsPanel";
import RolesPanel from "./RolesPanel";
import UsersPanel from "./UsersPanel";
// import { isEmail } from "hooks/useForm";
import { User } from "./UserItem";
import RobotsPanel from "./RobotsPanel";

interface ChoosePanelProps {
  administrator: boolean,
  organizationId: number;
  setUserSelected: React.Dispatch<React.SetStateAction<User | null>>;
  unit: number;
  onCreateGroup?: () => void;
  onCreateRole?: () => void;
  onOpenRobotsShop?: () => void;
}
interface Ref {
  getGroups: Function | undefined;
  getUsers: Function | undefined;
  getRoles: Function | undefined;
  getInvitedUsers: Function | undefined;
  getRobots: Function | undefined;
  getUsersUntilPage: ((userSelected: User) => Promise<void>) | undefined;
}
const USERS = 1;
const GROUPS = 2;
const ROLES = 3;
const ROBOTS = 4;

const ChoosePanel = forwardRef<Ref, ChoosePanelProps>(
  ({ organizationId, setUserSelected, unit, administrator, onCreateGroup, onCreateRole, onOpenRobotsShop }, ref) => {
    // to remove when implementing sse >>>>>>
    const groupRefreshRef = useRef<Function | undefined>(undefined);
    const userRefreshRef = useRef<Function | undefined>(undefined);
    const getUserUntilPageRef = useRef<((userSelected: User) => Promise<void>) | undefined>(undefined);
    const getInvitedUsersRef = useRef<Function | undefined>(undefined);
    const roleRefreshRef = useRef<Function | undefined>(undefined);
    const robotRefreshRef = useRef<Function | undefined>(undefined);
    // to remove when implementing sse <<<<<<
    // const user = useUser();
    // const { sendSnack } = useSnackbar();

    useEffect(() => {
      const reset = () => {
        setUserSelected(null);
      };
      reset();
      return reset;
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [unit, organizationId]);

    useImperativeHandle(
      ref,
      () => {
        if (organizationId && unit) {
          return {
            getUsersUntilPage: getUserUntilPageRef.current,
            getGroups: groupRefreshRef.current,
            getUsers: userRefreshRef.current,
            getInvitedUsers: getInvitedUsersRef.current,
            getRoles: roleRefreshRef.current,
            getRobots: robotRefreshRef.current,
          };
          //# just to refresh ref
        } else {
          return {
            getUsersUntilPage: undefined,
            getInvitedUsers: undefined,
            getGroups: undefined,
            getUsers: undefined,
            getRoles: undefined,
            getRobots: undefined,
          };
        }
      },
      [organizationId, unit]
    );

    // const handleGroupCreation = async (name: string) => {
    //   try {
    //     const createRes = await organizationsApi.post(`${organizationId}/groups`, {
    //       idorganization: organizationId,
    //       name,
    //       icon: null,
    //     });
    //     sendSnack({
    //       message: `${createRes.data.responsemessage}`,
    //       type: "success",
    //     });
    //     // to remove when implementing SSE
    //     groupRefreshRef.current && groupRefreshRef.current();
    //   } catch {
    //   } finally {
    //   }
    // };

    // const handleUserCreation = async (email: string) => {
    //   const createRes = await usersApi.post(
    //     `${user?.userId}/organizations/${organizationId}/inviteusers/dashboard`,
    //     { email: [email] }
    //   );
    //   sendSnack({
    //     message: `${createRes.data.responsemessage}`,
    //     type: "success",
    //   });
    //   // to remove when implementing SSE
    //   getInvitedUsersRef.current && getInvitedUsersRef.current();
    // };

    // const handleRoleCreation = async (name: string) => {
    //   try {
    //     const createRes = await organizationsApi.post(`${organizationId}/roles`, {
    //       idorganization: organizationId,
    //       name,
    //       icon: null,
    //     });
    //     sendSnack({
    //       message: `${createRes.data.responsemessage}`,
    //       type: "success",
    //     });
    //     // to remove when implementing SSE
    //     roleRefreshRef.current && roleRefreshRef.current();
    //   } catch {
    //   } finally {
    //   }
    // };

    return (
      <React.Fragment>
        <Stack height="100%" spacing={1}>
          <Fade
            style={{ overflow: "auto", height: "100%" }}
            unmountOnExit
            in={unit === USERS}
          >
            <Stack
              height="100%"
              display={unit !== USERS ? "none" : "flex"}
              spacing={2}
            >
              {/* {administrator && (
                <Box id="box-users" pt={1}>
                  <FastCreation
                    id="users"
                    validations={[({ value }) => isEmail(value) || { value: "Email non valida" }]}
                    label={getTranslation(translations, "user.email.label")}
                    onChange={handleUserCreation}
                  />
                </Box>
              )} */}
              <UsersPanel
                // to remove when implementing SSE
                ref={(ref) => {
                  userRefreshRef.current = ref?.getUsers
                  getUserUntilPageRef.current = ref?.getUserUntilPage
                  getInvitedUsersRef.current = ref?.getInvitedUsers
                }}
                onSelect={setUserSelected}
                organizationId={organizationId}
                administrator={administrator}
              />
            </Stack>
          </Fade>
          <Fade
            style={{ overflow: "auto", height: "100%" }}
            unmountOnExit
            in={unit === GROUPS}
          >
            <Stack
              height="100%"
              display={unit !== GROUPS ? "none" : "flex"}
              spacing={2}
            >
              {/* {administrator && (
                <Box id="box-groups" pt={1}>
                  <FastCreation
                    id="groups"
                    label={getTranslation(translations, "groups.edit.suggestnew")}
                    onChange={handleGroupCreation}
                  />
                </Box>
              )} */}
              <GroupsPanel
                // to remove when implementing SSE
                ref={(ref: any) => (groupRefreshRef.current = ref?.getGroups)}
                organizationId={organizationId}
                administrator={administrator}
                onCreateGroup={onCreateGroup}
              />
            </Stack>
          </Fade>
          <Fade
            style={{ overflow: "auto", height: "100%" }}
            unmountOnExit
            in={unit === ROLES}
          >
            <Stack
              height="100%"
              display={unit !== ROLES ? "none" : "flex"}
              spacing={2}
            >
              {/* {administrator && (
                <Box id="box-roles" pt={1}>
                  <FastCreation
                    id="roles"
                    label={getTranslation(translations, "roles.edit.suggestnew")}
                    onChange={handleRoleCreation}
                  />
                </Box>
              )} */}
              <RolesPanel
                // to remove when implementing SSE
                ref={(ref) => (roleRefreshRef.current = ref?.getRoles)}
                organizationId={organizationId}
                administrator={administrator}
                onCreateRole={onCreateRole}
              />
            </Stack>
          </Fade>
          {unit === ROBOTS && (
            <Fade style={{ overflow: "auto", height: "100%" }} unmountOnExit in>
              <Stack height="100%" spacing={2}>
                <RobotsPanel
                  ref={(ref) => (robotRefreshRef.current = ref?.getRobots)}
                  organizationId={organizationId}
                  administrator={administrator}
                  onOpenRobotsShop={onOpenRobotsShop}
                />
              </Stack>
            </Fade>
          )}
        </Stack>
      </React.Fragment>
    );
  }
);

export default ChoosePanel;
